export var DimensionEventEnum;

!function(DimensionEventEnum) {
    DimensionEventEnum.dimensionHover = "dimensionHover", DimensionEventEnum.dimensionClick = "dimensionClick";
}(DimensionEventEnum || (DimensionEventEnum = {}));
//# sourceMappingURL=interface.js.map
